import { ISelectOption, Select } from '@aon/aon-tws-common-ui';
import React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';

export interface IPageFlowQuestionSectionProps {
	questions: ISelectOption[];
	questionError: boolean;
	questionId: string;
	disabled?: boolean;
	handleQuestionChange: (value: any) => void;
}

const SelectContainer = styled.div.attrs<{}>({
	className: 'tws-select-container',
})`
	width: 50%;
`;
SelectContainer.displayName = 'SelectContainer';

export const PageFlowQuestionSection = (props: IPageFlowQuestionSectionProps) => {
	return (
		<Select
			items={props.questions}
			size='md'
			selectSize='xlg'
			dropdownSize='xlg'
			onApply={props.handleQuestionChange}
			displayText={ContentConstants.LOGIC_AND_LAYOUT.SELECT_QUESTION}
			error={props.questionError}
			message={ContentConstants.LOGIC_AND_LAYOUT.QUESTION_ERROR_MESSAGE}
			selectedValue={props.questionId}
			disabled={props.disabled}
		/>
	);
};
